import { useState, useEffect, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { ApiGet } from '../Api';
import Modal from 'react-modal';
import logo from './jofood_logo.png';
import { GetTime } from '../Function';
import TopBar from '../TopBar';

function JOFoodFEMS() {
  Modal.setAppElement('#root')
  
  const logoHeight = '60px'; //logo height + logo paddingTop
  const gridGap = window.innerWidth > 800 ? 30 : 20;
  const backgroundMainColor = 'rgb(12, 35, 64)';
  const backgroundSubColor = 'rgb(18, 46, 78)';
  const titleColor= 'rgb(153, 255, 153)';

  const [gridStyle, setGridStyle] = useState(GetGridStyle());
  const [freezer1LineOption, setFreezer1LineOption] = useState(GetLineOption());
  const [freezer2LineOption, setFreezer2LineOption] = useState(GetLineOption());
  const [freezer3LineOption, setFreezer3LineOption] = useState(GetLineOption());
  const [co2GaugeOption, setCo2GaugeOption] = useState(GetGaugeOption());
  const [totalGaugeOption, setTotalGaugeOption] = useState(GetGaugeOption());
  const [freezer1GaugeOption, setFreezer1GaugeOption] = useState(GetGaugeOption());
  const [freezer2GaugeOption, setFreezer2GaugeOption] = useState(GetGaugeOption());
  const [freezer3GaugeOption, setFreezer3GaugeOption] = useState(GetGaugeOption());

  const chartRefs = useRef([]);
  let intervalId;

  function Resize() {
    setGridStyle(GetGridStyle());
  };

  useEffect(() => {
    document.title = 'JOFOOD MONITORING';

    window.addEventListener('resize', Resize);

    Inquiry();

    intervalId = setInterval(()=>{
      Inquiry();
    }, 1000 * 60);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }

      window.removeEventListener('resize', Resize);

      for (const chartRef of chartRefs.current) {
        if (chartRef) {
          chartRef.dispose();
        }
      }
      chartRefs.current = [];

      setGridStyle(null);
      setFreezer1LineOption(null);
      setFreezer2LineOption(null);
      setFreezer3LineOption(null);
      setCo2GaugeOption(null);
      setTotalGaugeOption(null);
      setFreezer1GaugeOption(null);
      setFreezer2GaugeOption(null);
      setFreezer3GaugeOption(null);
    };
  }, []);
  
  async function Inquiry() {
    const response = await ApiGet(`${process.env.REACT_APP_API_DOMAIN}jo-food/fems`);
    if (response !== null && response.ok) {
      const json = await response.json();
      setCo2GaugeOption(GetGaugeOption('CO2 발생량', json.previousCo2, json.co2, 'kg'));
      setTotalGaugeOption(GetGaugeOption('전체 사용 전력량', 0, 0, 'kWh'));
      setFreezer1GaugeOption(GetGaugeOption('냉동창고1 사용 전력량', json.previousPower[0].power, json.power[0].power, 'kWh'));
      setFreezer2GaugeOption(GetGaugeOption('냉동창고2 사용 전력량', json.previousPower[1].power, json.power[1].power, 'kWh'));
      setFreezer3GaugeOption(GetGaugeOption('냉동창고3 사용 전력량', json.previousPower[2].power, json.power[2].power, 'kWh'));
      setFreezer1LineOption(GetLineOption('냉동창고1 전류', json.current.freezer1));
      setFreezer2LineOption(GetLineOption('냉동창고2 전류', json.current.freezer2));
      setFreezer3LineOption(GetLineOption('냉동창고3 전류', json.current.freezer3));
      setTotalGaugeOption(GetGaugeOption('전체 사용 전력량', json.previousTotalPower, json.totalPower, 'kWh'));
    }
  }

  function GetGridStyle() {
    return {
      display: 'grid',
      gap: gridGap,
      padding: gridGap,
      backgroundColor: backgroundMainColor,
      width: '100vw',
      height: `calc(100vh - ${logoHeight})`,
      boxSizing: 'border-box', // 패딩을 포함하여 크기 계산
      overflow: 'auto',
      scrollbarWidth: 'none',
      gridTemplateColumns: window.innerWidth > 800 ? 'repeat(4, 1fr)' : 'repeat(1, 1fr)'
    };
  };

  const gridItemStyle = {
    backgroundColor: backgroundSubColor,
    borderRadius: '10px',
    height: `calc((100vh - ${gridGap*3}px - ${logoHeight}) / 2)`, // 행 수에 맞게 높이를 계산, 2행이니 세로 간격의 총합 = padding 20px * 2 + gap 20px = 60px,
  };

  const eChartsStyle = { width: '100%', height: '100%' };

  function GetLineOption(title, data) {
    return {
      grid: {
        top: '20%',
        left: '10%',
        right: '10%',
        bottom: '20%'
      },
      title: {
        text: title,
        left: 'center',
        top: 20,
        textStyle: {
          color: titleColor,
          fontSize: window.innerWidth > 800 ? 30 : 25
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          animation: false
        }
      },
      xAxis: {
        type: 'time',
        //type: 'category',
        axisLine: {
          lineStyle: {
            color: 'white',
          }
        },
        axisLabel: {
          //interval: 2,  //모든 데이터에 레이블을 표시
          rotate: 45,    //레이블 각도
          //fontSize: 10,   //폰트 크기
        },
      },
      yAxis: {
        type: 'value',
        name : 'A',
        axisLine: {
          lineStyle: {
            color: 'white',
          }
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: 'gray',
          }
        },
        axisLabel: {
          formatter: function (value) {
            return value.toLocaleString();
          },
          color: 'white'
        }
      },
      series: [
        {
          data: data,
          type: 'line',
          symbol: 'none',
          //smooth: true,
          /*label: {
            show: true,
            position: 'right', 
            color: 'white',
            fontSize: 16,
            textBorderColor: 'black',
            textBorderWidth: 2,
          },*/
          itemStyle: {
            color: 'yellow',
          },
        },
      ],
    };
  }

  function GetGaugeOption(title, data1, data2, unit) {
    return {
      title: {
        text: title,
        left: 'center',
        top: 20,
        textStyle: {
          color: titleColor,
          fontSize: 30
        }
      },
      series: [
        {
          type: 'gauge',
          radius: '65%',
          max: unit === 'kg' ? 400 : 4000,//Math.ceil((data1 > data2 ? data1 * 1.5 : data2 * 1.5) / 100) * 100,
          anchor: {
            show: true,
            showAbove: true,
            size: 18,
            itemStyle: {
              //color: 'yellow'
            },
          },
          pointer: {
            icon: 'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
            width: 5,
            length: '60%',
            offsetCenter: [0, 0],
          },
          progress: {
            show: true,
            overlap: true,
            roundCap: true
          },
          axisLine: {
            roundCap: true
          },
          axisTick: {
            lineStyle: {
              color: 'white' //눈금 색
            }
          },
          splitLine: {
            lineStyle: {
              color: 'white' //분할선 색
            }
          },
          axisLabel: {
            color: 'white' //눈금 숫자 색
          },
          data: [
            {
              value: data1,
              name: 'LAST MONTH',
              title: {
                color: 'white',
                offsetCenter: ['-80%', '90%']
              },
              detail: {
                offsetCenter: ['-80%', '110%'],
                //backgroundColor:'red'
                width: 80
              }
            },
            {
              value: data2,
              name: 'CURRENT MONTH',
              title: {
                color: 'white',
                offsetCenter: ['80%', '90%']
              },
              detail: {
                offsetCenter: ['80%', '110%'],
                width: 80
              }
            }
          ],
          title: {
            fontSize: 14
          },
          detail: {
            width: 40,
            height: 14,
            fontSize: 14,
            color: '#fff',
            backgroundColor: 'inherit',
            borderRadius: 3,
            formatter: function (value) {
              return value.toLocaleString() + unit; 
            }
          }
        }
      ]
    };
  }

  function OnChartReady(instance) {
    chartRefs.current.push(instance);
  }

  const logoContent = (
    <img src={logo} width={'40px'} height={'40px'} style={{ marginLeft: 10, marginTop: 10 }} />
  );

  return (
    <div onContextMenu={(event)=>{ event.preventDefault(); }}>
      <TopBar logo={logoContent} title={''} />

      <div style={gridStyle}>
        <div style={gridItemStyle}>
          <ReactECharts option={totalGaugeOption} style={eChartsStyle} onChartReady={OnChartReady}/>
        </div>
        <div style={gridItemStyle}>
          <ReactECharts option={freezer1GaugeOption} style={eChartsStyle} onChartReady={OnChartReady}/>
        </div>

        <div style={gridItemStyle}>
          <ReactECharts option={freezer2GaugeOption} style={eChartsStyle} onChartReady={OnChartReady}/>
        </div>

        <div style={gridItemStyle}>
          <ReactECharts option={freezer3GaugeOption} style={eChartsStyle} onChartReady={OnChartReady}/>
        </div>
        <div style={gridItemStyle}>
          <ReactECharts option={co2GaugeOption} style={eChartsStyle} onChartReady={OnChartReady}/>
        </div>

        <div style={gridItemStyle}>
         {/*<input type='date' id='infra' value={date.infra} onChange={DateOnChange} />*/}
          <ReactECharts option={freezer1LineOption} style={eChartsStyle} onChartReady={OnChartReady}/>
        </div>

        <div style={gridItemStyle}>
          {/*<input type='date' id='server' value={date.server} onChange={DateOnChange}/>*/}
          <ReactECharts option={freezer2LineOption} style={eChartsStyle} onChartReady={OnChartReady}/>
        </div>

        <div style={gridItemStyle}>
          {/*<input type='date' id='airConditioner' value={date.airConditioner} onChange={DateOnChange}/>*/}
          <ReactECharts option={freezer3LineOption} style={eChartsStyle} onChartReady={OnChartReady}/>
        </div>
      </div>
    </div>
  );
}

export default JOFoodFEMS;